import React from 'react';
import { numericValidation} from '../../../Utils/CommonFunctions';

const numberField = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	return (
	    <input type="text" 
	    	className={fieldDetail.classname} 
	    	onChange={props.changed} 
	    	name={props.fieldKey} 
	    	placeholder={fieldDetail.placeHolder} 
	    	value={fieldDetail.value}
	    	onKeyPress={numericValidation}
	    />
	);
}

export default numberField;